<div class="asc-panel mat-elevation-z2">
   @if (isSettingsMenuVisible) {
   <asc-settings-menu />
   }
   @if (isSettingsPanelVisible) {
   <div class="asc-area-content">
      <router-outlet></router-outlet>
   </div>
   }
</div>